export const formatDateString = (date: string) => {
  const slicedDate = date.split('/');
  const result = `${slicedDate[2]}-${slicedDate[1]}-${slicedDate[0]}`;
  return result;
};
